import CustomButton from "components/CustomButton";
import CustomModal from "components/CustomModal";
import Input from "components/form/Input";
import useDidMount from "hooks/useDidMount";
import isEmpty from "lodash/isEmpty";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { tryUpdatePredictionCampaign ,tryCreatePredictionCampaign } from "redux/slices/predictionSlice";


export default function PredictionCampaignForm({ loading, showModal, setShowModal }) {
  const dispatch = useDispatch()

  const {
    campaign: { data }
  } = useSelector((state) => state.prediction)

  const [title, setTitle] = useState("");

  const onSubmit = () => {
    dispatch(tryCreatePredictionCampaign({
      title,
    }))
  }

  useEffect(() => {
    if (!isEmpty(showModal)) {
      setTitle(showModal?.title)
    }
  }, [showModal])

  useDidMount(() => {
    resetForm()
  }, [data])

  const resetForm = () => {
    setTitle("");
  }

  const onUpdate = () => {
    dispatch(tryUpdatePredictionCampaign(
      {
        prediction_campaign_id: showModal.id,
        payload: {
          title,
        }
      }))
  }

  const isEdit = !isEmpty(showModal)

  return (
    <>
      <CustomModal
        title="Create Prediction Campaign" children={
          <div>
            <div className="flex space-x-5">
              <Input
                type="text"
                color="blue"
                placeholder="Title"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value)
                }}
              />
            </div>
          </div>
        }
        showModal={!!showModal}
        button={
          <CustomButton onClick={isEdit ? onUpdate : onSubmit} disabled={loading}>
            {isEdit ? 'Update' : 'Create'}
          </CustomButton>
        }
        setShowModal={() => {
          resetForm()
          setShowModal()
        }}
        loading={loading}
      />
    </>
  );
}
